const TYPES = {
    FETCH_START:    '[STATISTICS][SERVERS] FETCH START',
    FETCH_SUCCESS:  '[STATISTICS][SERVERS] FETCH SUCCESS'
};

export default TYPES;